// src/services/recouvrementService.js
import axiosInstance from "./api_helper";

const RECOUV_BASE = "/api/recouvrement";
/** yyyy-MM-dd */
const toISODate = (d) => {
  if (!d) return undefined;
  if (typeof d === "string") return d; // already yyyy-MM-dd
  return new Date(d).toISOString().slice(0, 10);
};

/** month: 1..12 */
const monthRange = (year, month) => {
  const y = year ?? new Date().getFullYear();
  const m = (month ?? new Date().getMonth() + 1) - 1; // 0-based
  const startDate = new Date(y, m, 1);
  const endDate = new Date(y, m + 1, 0);
  return { dateDebut: toISODate(startDate), dateFin: toISODate(endDate) };
};
const recouverementService = {

  /**
   * Calendrier direction:
   * total + count par dateEcheance (chèques EN_ATTENTE)
   */
  getChequesSummary: (params) =>
    axiosInstance.get(`${RECOUV_BASE}/cheques/summary`, { params }),

  getChequesSummaryAll: (params) =>
    axiosInstance.get(`${RECOUV_BASE}/cheques/summary`, { params: { ...params, statut: null } }),

  getChequesSummaryPending: (params) =>
    axiosInstance.get(`${RECOUV_BASE}/cheques/summary`, { params: { ...params, statut: "EN_ATTENTE" } }),

  /**
   * Calendrier des échéances (factures uniquement)
   * Backend: GET /api/recouvrement/echeances/calendar?start=YYYY-MM-DD&end=YYYY-MM-DD&clientId=&onlyOpen=
   */
  getCalendar: (params) =>
    axiosInstance.get(`${RECOUV_BASE}/echeances/calendar`, { params }),

  /**
   * Détails d'une date (clic sur le montant du calendrier)
   */
  getChequesByDate: (params) =>
    axiosInstance.get(`${RECOUV_BASE}/cheques`, { params }),

  /**
   * Helpers: récupérer summary pour un mois (année/mois 1..12)
   */
  getChequesSummaryMonth: ({ year, month, clientId, banque, query } = {}) => {
    const { dateDebut, dateFin } = monthRange(year, month);
    return axiosInstance.get(`${RECOUV_BASE}/cheques/summary`, {
      params: { dateDebut, dateFin, clientId, banque, query },
    });
  },

  /**
   * Helper: récupérer détails d'une date donnée
   */
  getChequesDetailsDay: ({ dateEcheance, clientId, banque, query } = {}) =>
    axiosInstance.get(`${RECOUV_BASE}/cheques`, {
      params: { dateEcheance: toISODate(dateEcheance), clientId, banque, query },
    }),


  /* =========================================================================
   * ✅ Backward compatibility (ancienne impl)
   * NOTE: si ton front/saga utilise encore getAll(), on le redirige vers le
   * nouveau summary chèques (mois courant), pour ne rien casser.
   * ========================================================================= */

  /**
   * Alias (compat saga actuelle) :
   * retourne le summary chèques du mois courant (dateEcheance)
   */
  getAll: (params = {}) => {
    const { dateDebut, dateFin } = monthRange();
    const defaultParams = { dateDebut, dateFin };
    return axiosInstance.get(`${RECOUV_BASE}/cheques/summary`, {
      params: { ...defaultParams, ...params },
    });
  },

  /**
   * Alias: calendrier (ancienne signature start/end) -> map vers dateDebut/dateFin
   * Utile si tu as déjà une page calendrier qui envoie start/end.
   */
  getCalendar: (params = {}) => {
    const mapped = {
      dateDebut: params.dateDebut ?? params.start,
      dateFin: params.dateFin ?? params.end,
      clientId: params.clientId,
      banque: params.banque,
      query: params.query,
    };
    return axiosInstance.get(`${RECOUV_BASE}/cheques/summary`, { params: mapped });
  },

  /**
   * Helper générique: mois (ancienne signature) -> summary
   */
  getMonth: ({ year, month, clientId, banque, query } = {}) =>
    recouverementService.getChequesSummaryMonth({ year, month, clientId, banque, query }),

  /* =========================================================================
   * (Optionnel) Export Excel
   * Si tu ajoutes un endpoint backend plus tard:
   *   GET /api/recouvrement/cheques/export?dateDebut=...&dateFin=...&...
   *   => responseType: 'blob'
   * ========================================================================= */

  exportChequesExcel: (params) =>
    axiosInstance.get(`${RECOUV_BASE}/cheques/export`, {
      params,
      responseType: "blob",
    }),
};



export default recouverementService;